// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcd4843b","699":"aa87eb8b"}[chunkId] + ".chunk.js";
};